<template>
    <div id="WarrantyClaimComment">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="d-flex align-items-center justify-content-between">
          <h4>Comment History</h4>
          <button class="btn btn-primary" :disabled="openClosedValue == 'Closed'" type="button" v-on:click="openCommentModal()">Add
            Comments</button>
        </div>
        <template>
          <template v-if="commentArr.length > 0">
            <ul class="comment-box">
              <li v-for="(responses, key) in commentArr">
                <div class="comment-details">
                  <div class="comment-dec">
                    <span class="user">{{ responses.createdUser }}</span>
                    <span class="ml-2 comment-time">{{ responses.comment_date }}</span>
                  </div>
                  <p class="mb-1">{{ responses.comment }}</p>
                </div>
              </li>
            </ul>
          </template>
          <template v-else>
            <p class="no-data"> No comment available </p>
          </template>
        </template>

        <div class="modal fade policy-modal" id="addCommentModal" ref="addCommentModal" data-backdrop="static"
          data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">New Comment</h5>
              </div>
              <div class="modal-body">
                <textarea class="form-control" v-model.trim="comment" rows="3" maxlength="3000"
                  placeholder="Write comment"></textarea>
                <div class="col-md-12 mt-0 pr-0 text-right">
                  <span>{{ commentCharsCount }}/3000</span>
                </div>
                <span v-if="comment_error_msg" class="field-error">{{ comment_error_msg }}</span>
              </div>
              <div class="modal-footer">
                <button class="btn btn-primary" type="button" v-on:click="addComment()">Submit</button>
                <button class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import moment from 'moment';
import 'moment-timezone';

export default {
    name: "WarrantyClaimComments",
    components: {
        appFooter: () => import('@/components/Footer')
    },
    mixins: [commonMixins,contractMixins],
    props: {
      openClosedValue: {
        type: String,
        default: 'Open'
      }
    },
    data: () => ({
        permissions: [],
        createErrorMsg:"",
        deleteError:"",
        cantAccessPage: "",
        canAddComment : false,
        canEditComment : false,
        canDeleteComment : false,
        comment:"",
        comment_error_msg:"",
        submitBtn:"Add Comment",
        loading:false,
        customerCommentId:0,
        commentArr:[],
        commentFound:false,
        commentTypeArr:[],
        comment_type_error_msg:"",
        comment_type_id:null,
        flag:'firstload',
        record_limit:0,
        totalComments:0,
        search_comment:"",
        updateComment: false,
        currentIndex: null,
        userObj: JSON.parse(localStorage.getItem("user_obj")),
        claimNumber: "",
        commentCharsCount: 0,
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;

            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {

                    if(permissions[i].name == 'view_customer_comment') {
                        self.cantAccessPage = true;

                    }

                    if(permissions[i].name == 'add_customer_comment') {
                        self.canAddComment = true;
                        self.canEditComment = true;
                    }

                    if(permissions[i].name == 'delete_customer_comment') {
                        self.canDeleteComment = true;
                    }

                }

            }

        },
        comment: function (newValue){
          if (newValue.length > 3000) {
            this.comment = newValue.substring(0, 3000);
          }
          this.commentCharsCount = newValue.length;
        }

    },
    mounted: function() {
        var self = this;
        if ( self.moduleId == undefined){

            self.getPermissions();

        }
        self.loadFieldData(['warranty_claim_comment']);
        // self.getCommentsFromClaimNumber();
        // self.getComments();

    },
    methods: {
      markCommentSeen() {
        var self = this;        
        if (self.commentArr.length > 0) {
          let commentIds = self.commentArr.map(item => item.id);
          var fields = {
            'ids': commentIds
          }
          $.ajax({
            url: process.env.ROOT_API + "/warranty-claim/mark-comment-seen",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
            },
            error: function (jqXHR, exception) {
              self.generateStatusCodeMessage(jqXHR, true);
            },
          });
        }
      },
      openCommentModal() {
        this.comment = '';
        this.comment_error_msg = '';
        $('#addCommentModal').modal('show');
      },
        addComment(index){
          var self = this;
          var success = true;
          self.comment_error_msg = "";
          if(self.comment == "" || self.comment == null){
            self.comment_error_msg = "Comment is Required!";
            success = false;
          }

          if(success){
            self.$swal({
              title: 'Comments Cannot Be Changed or Deleted. Do You Want to Submit?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, Submit',
              cancelButtonText: 'No, Cancel',
              showCloseButton: false,
            }).then((result) => {
              if (result.value) {
                // Combine first and last name, adding a space only if both are present
                var userFullName = [self.userObj.first_name, self.userObj.last_name].filter(Boolean).join(' ');
                self.commentArr.unshift({
                  'id': '',
                  'comment_by': self.userObj.id,
                  'comment_by_name': self.userObj.first_name,
                  'createdUser': userFullName,
                  'claim_number': self.claimNumber,
                  'comment': self.comment,
                  'comment_date': moment().tz('PST8PDT').format('hh:mm A (MM/DD/YYYY)'),
                });

                self.comment = "";
                self.comment_error_msg = "";
                self.emitDataToClaimTab();
                $('#addCommentModal').modal('hide');
              }
            });
          }
        },
        spliceComment(index){
          var self = this;
          self.commentArr.splice(index,1);
          self.emitDataToClaimTab();
        },
        alterComment(index){
          var self = this;
          self.comment = self.commentArr[index].comment;
          self.comment_type_id = self.commentArr[index].comment_type;
          self.updateComment = true;
          self.currentIndex = index;
        },
        getDataFromParent(commentData){
          this.commentArr = commentData;
          // after loading all the comments,
          // mark them seen by the loggedin user
          this.markCommentSeen();
        },
        emitDataToClaimTab(){
          var self = this;
          self.$emit("send-comment-data-claim-tab",self.commentArr);
        },
        clearAllFields(){
          var self = this;
          self.commentArr = [];
          self.comment = '';
          self.comment_error_msg = '';
        }
      },
}
</script>


// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/WarrantyClaimComments.vue